import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";

export default function Layout() {
  const loc = useLocation();
  const hideNav = /^\/(lecteur|bebe\/lecteur|decouverte)/.test(loc.pathname);
  return (
    <div className="grain min-h-screen relative">
      <div className={`mx-auto max-w-md w-full px-5 safe-top relative z-10 ${hideNav ? "pb-8" : "pb-32"}`}>
        <Outlet />
      </div>
      {!hideNav && <BottomNav />}
    </div>
  );
}
